module.exports = __webpack_public_path__ + "static/media/icon-code-of-practice-no-information.9717b91a.svg";